module.exports = __webpack_public_path__ + "static/ball-of-collusion-6063692e84e35c2c715577a6602c683f.jpg";